export default (data, value, text) => {
  if (Array.isArray(data)) {
    return data.map((item) => ({ value: item[value], text: item[text] }));
  }
};
